import * as React from 'react';
import cx from 'classnames';
import "./styles.scss";
var styles = {
  "badge": "_1m25p",
  "primary": "_3mq6g",
  "inverted": "PWMhy",
  "counter": "_3eUX-",
  "list": "_2gI5j",
  "isMax": "_10OIe",
  "new": "_1oLha",
  "dot": "H5ybV",
  "wrapper": "_2YM_i"
};
import { typeFontRegularClass, typeSizeFootClass } from "@nebula/styles/typography";
import { composeStyles, cssAlignSelf, cssMargin, cssOrder, cssVerticalAlign } from '@nebula/system-props';
var MAX_VALUE = 99;
var BadgeRenderFunction = function BadgeRenderFunction(props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'counter' : _props$variant,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$count = props.count,
    count = _props$count === void 0 ? 0 : _props$count,
    children = props.children,
    onClick = props.onClick,
    horizontalOffset = props.horizontalOffset,
    verticalOffset = props.verticalOffset;
  var hasChildren = Boolean(children);
  var badgeText = '';
  if (variant === 'new') {
    badgeText = 'New';
  } else if (variant === 'counter' && count > 0) {
    badgeText = String(Math.min(Math.floor(count), MAX_VALUE));
  }
  var customStyles = composeStyles(props, [cssAlignSelf, cssMargin, cssOrder, cssVerticalAlign]);
  var badgeClassNames = cx(styles.badge, styles[variant], styles[color], variant === 'counter' && count > MAX_VALUE && styles.isMax, !hasChildren && styles.list, typeFontRegularClass, typeSizeFootClass);
  var badge = badgeText || variant === 'dot' ? /*#__PURE__*/React.createElement("span", {
    className: badgeClassNames,
    style: hasChildren ? {
      top: verticalOffset,
      right: horizontalOffset
    } : customStyles
  }, badgeText) : null;
  if (!children) return badge;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: styles.wrapper,
    style: customStyles,
    onClick: onClick
  }, children, badge);
};
export var Badge = /*#__PURE__*/React.forwardRef(BadgeRenderFunction);
export default Badge;